
























































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import FormBase from '../../../components/helper/form-base.vue';
import VWidget from '@/components/VWidget.vue';
import Company from '@/views/admin/company/company.vue';
import GeneralTypes from '@/views/preferences/generaltype/generaltype.vue';
import Concepts from '@/views/casis/concept/concept.vue';
import Categories from '@/views/extranet/category/category.vue';
import Dealers from '@/views/admin/dealer/dealer.vue';
import Zones from '@/views/admin/zone/zone.vue';
import Manufacturers from '@/views/admin/manufacturer/manufacturer.vue';
//import Employees from '@/views/admin/employee/employee.vue';
import Holidays from '@/views/casis/holiday/holiday.vue';
import Ratios from '@/views/casis/ratio/ratio.vue';
import Segments from '@/views/tracing/segment/segment.vue';


@Component({
    components: { VWidget, FormBase, Company, GeneralTypes, Concepts, Dealers, Zones, Categories, Manufacturers, Holidays, Ratios, Segments }
})
export default class Departments extends ListBase {
    model: any = {};
    tabModel: any = null;
    formBase: boolean = false;
    file: null;

    get saving() {
        return this.$store.state.configuration.loading;
    }

    generalItems = [
        this.gItem({ type: 'subheader', subheader: 'Configuracion' }),
        this.gItem({ type: 'text', prop: 'WARRANTY_LINK', label: 'Url para cargar sistema de garantias', size: 6 }),
        this.gItem({ type: 'text', prop: 'TTR_LINK', label: 'Url Plataforma TTR CEM', size: 6 }),
        this.gItem({ type: 'subheader', subheader: 'Alertas CASIS y CEM' }),
        this.gItem({ type: 'email', prop: 'ALERT_EMAIL', label: 'Correo adicional para envio de alertas', hint: 'Se usara para la paginacion de las listas del sistema', persistentHint: true, size: 3 }),
        this.gItem({ type: 'select', prop: 'CASIS_ALERT_DAY', label: 'Dia de notificacion para CASIS', hint: 'Indique el un DIA de la semana para enviar las alertas de CASIS', persistentHint: true, options: 'week_days', size: 3 }),
        this.gItem({ type: 'select', prop: 'CEM_ALERT_DAY', label: 'Dia de notificacion para CEM', hint: 'Indique el DIA de la semana para enviar las alertas de CEM', persistentHint: true, options: 'week_days', size: 3 }),
        this.gItem({ type: 'text', prop: 'FIRST_MODEL_YEAR', label: 'Anio de inicio para calculo de Segmentos', size: 3 }),
        
        this.gItem({ type: 'subheader', subheader: 'Alertas Seguimiento' }),
        this.gItem({ type: 'number', prop: 'TRACING_ALERT_DAY', label: 'Dias Antes de Vencimiento', suffix: 'Dias', hint: 'Indica la cantidad de dias previos a vencimiento para notificar', persistentHint: true, size: 4 }),
        this.gItem({ type: 'switch', prop: 'ENABLE_ALERT_TODAY', label: 'Enviar alerta el dia de vencimiento', size: 4 }),
        this.gItem({ type: 'switch', prop: 'ENABLE_ALERT_DUE', label: 'Enviar alerta cuando se haya vencido', size: 4 }),
        this.gItem({ type: 'subheader', subheader: 'Integraciones API Consulta CEM' }),
        this.gItem({ type: 'text', prop: 'CEM_INTER_API', label: 'API de integracion para dealers Internos', size: 4 }),
        this.gItem({ type: 'text', prop: 'CEM_INTER_TOKEN', label: 'Token de integracion para API de dealers Internos', size: 8 }),

        this.gItem({ type: 'subheader', subheader: 'Integracion API Consulta CASIS' }),
        this.gItem({ type: 'text', prop: 'CASIS_API', label: 'API de integracion para Consulta de Casis', size: 12 }),

    ]

    buildModel(data) {
        let items = [...this.generalItems]
        let model = { };
        items.forEach(item => {
            if (item.prop != undefined && typeof data[item.prop] == "object") {
                var prop = item.prop;
                if (data[item.prop] != undefined) {
                    model[prop] = data[item.prop].id;
                }
            } else if (item.prop != undefined) {
                model[item.prop] = data[item.prop];
            }

        });
        return model;
    }

    async save() {           
        let model = this.buildModel(this.model);
        await this.$store.dispatch({
            type: 'configuration/save',
            data: model
        });
        Util.abp.notify.success(this, 'Los ajustes han sido actualizados correctamente.');
    }

    mounted() {
        this.model = Util.extend(true, {}, Util.abp.setting.values);
    }

    async created() {
        this.formBase = true;
    }
}
